export const KSA = "Saudi Arabia";
